import { Component, OnInit, Inject, Input } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { PreferencesService } from '../../preferences.service';
import { UCComponentInspectionOrderVM } from '../../models/preferences.model';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-component-inspection-order',
  templateUrl: './component-inspection-order.component.html',
  styleUrls: ['./component-inspection-order.component.scss']
})
export class componentinspectionordercomponent implements OnInit {
  
  inspectionId: number;
  showMeasurementCounts: boolean = false;
  UCComponentInspectionOrderList: UCComponentInspectionOrderVM[] = [];
  
  loading = false;

  constructor(private _dialogRef: MatDialogRef<componentinspectionordercomponent>,
    private readonly _pref: PreferencesService,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _notify: NotificationsService,
  private _fb: FormBuilder) { }

  ngOnInit() {
    this.getComponentInspectionOrderList();
    this.showMeasurementCounts = this._data.showMeasurementCounts;
  }

  onCloseClick(): void {
    this._dialogRef.close(false);
  }

  getComponentInspectionOrderList() {
    this.loading = true;
    this._pref.getComponentInspectionOrderList().subscribe(res => {
      console.log("component Types", res)
      this.UCComponentInspectionOrderList = res;
      //this.ReportCompartTypeList = this.ReportConfigList.filter((item, i, arr) => arr.findIndex((t) => t.Id === item.Id) === i)
      this.loading = false;
    },
      error => {
        console.error(error);
        this._notify.error('Error', 'Error while fetching Component Types.');
        this.loading = false;
      }
    );
  }

  setMeasurementCounts(id: number, event: any) {
    this.loading = true;
    this._pref.setMeasurementCounts(id, event.target.value).subscribe(res => {
      if (res == true) {
        //this.getComponentInspectionOrderList();
      }
      this.loading = false;
    })
  }

  recalculateSortOrder(Id: number, sortOrder: number, incrementOrder: number) {
    this.loading = true;
    this._pref.recalculateSortOrder(Id, sortOrder, incrementOrder).subscribe(res => {
      if (res == true) {
        this._notify.success('Sort order updated Successfully.');
        this.getComponentInspectionOrderList();
      }
      this.loading = false;
    })
  }

  setInspectInRevrseFlag(id: number, event: any) {
    this.loading = true;
    this._pref.setInspectInRevrseFlag(id, event.checked).subscribe(res => {
      if (res == true) {
        //this.getComponentInspectionOrderList();
        this._notify.success('Sort order updated Successfully.');
      }
      this.loading = false;
    })
  }

}
